/** Tek kaynak: WhatsApp / Instagram dış yönlendirmeleri */
export const WHATSAPP_PHONE_E164 = '905431910851';

/** Mobil ve masaüstü tarayıcılarda güvenilir sohbet açılışı */
export const WHATSAPP_CHAT_URL = `https://api.whatsapp.com/send?phone=${WHATSAPP_PHONE_E164}`;

/** Profil sayfası (www + sondaki slash, yönlendirme tutarlılığı için) */
export const INSTAGRAM_PROFILE_URL = 'https://www.instagram.com/nigpak.temizlik/';

export const TEL_HREF = `tel:+${WHATSAPP_PHONE_E164}`;
